module.exports = __webpack_public_path__ + "assets/images/TZSN-logo-small.png";